import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Search, } from "@mui/icons-material";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { useHistory } from "react-router-dom";
import {
  TextField,InputAdornment
} from "@mui/material";

const Header = ({ children, hasHiddenAuthButtons }) => {
  const history = useHistory();

  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  return (
    <Box className="header">
      <Box className="header-title">
        <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>      
      { localStorage.getItem("token") !== null ? 
        <Box style={{ "width" : 250 }}>
          {children} 
        </Box> : null
      } 
      { hasHiddenAuthButtons ? (
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={() => history.push("/", { from: "products" })}
        >
          Back to explore
        </Button>
      ) : (
        <div>
          {localStorage.getItem("token") !== null ? (
            <Stack direction="row" spacing={1} alignItems="center">
              <Avatar alt={localStorage.getItem("username")} src="avatar.png" />
              <span className="username-text">{localStorage.getItem("username")}</span>
              <Button onClick={() => logout()}>Logout</Button>
            </Stack>
          ) : (
            <div>
              <Button
                onClick={() => history.push("/login", { from: "products" })}
              >
                Login
              </Button>
              <Button
                className="button"
                variant="contained"
                onClick={() => history.push("/register", { from: "products" })}
              >
                Register
              </Button>
            </div>
          )}
        </div>
      )}
    </Box>
  );
};

export default Header;
